import type { TFile } from '../@types/file';

export const ROLE_USER = ['administrator', 'manage', 'teacher', 'client'] as const;
export type RoleUser = (typeof ROLE_USER)[number];

export type UserType = {
  accessToken: string;
  address: string | null;
  avatar: TFile | null;
  birthday: Date | null;
  createdAt: Date | null;
  curentLogin: string | null;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  gender: 0 | 1; // 0 nữ, 1: nam,
  id: string;
  phoneNumber: number | null;
  role: RoleUser;
  uid: string;
  updatedAt: Date;
  username: string;
  isChangePassword: boolean;
} | null;

export type AuthState = {
  user: UserType;
  loading: boolean;
};

export type AuthContextValue = {
  user: UserType;
  loading: boolean;
  authenticated: boolean;
  unauthenticated: boolean;
  checkUserSession?: () => Promise<void>;
};
